if (jQuery('#event-registration-form').length > 0) {
    var form = new Vue({
        el: '#event-registration-form',
        data: {
            attendeeName: '',
            attendeePosition: '',
            lunch: '',
            venue: '',
            workshop1: '',
            workshop2: '',
            workshop3: '',
            workshop4: '',
            workshop5: '',
            workshop6: '',
            formNoError: false,
            schoolName: '',
            address: '',
            contactEmail: '',
            rollNo: ''
        },
        mounted: function () {
        },
        methods: {
            submitForm: function () {
                //validate only first group of inputs and number of attendees
                jQuery('form#form-register-event').parsley().validate({group: 'form'});
                jQuery('form#form-register-event').parsley().validate({group: 'attendee'});
                if (this.formNoError) {
                    //you can submit the form now, there is no error
                    var _this = this;
                    jQuery.post("/app/themes/fssu/form-actions/submit-event-registration.php", {
                        event_id: jQuery('#event-id').val(),
                        name: _this.schoolName,
                        email: _this.contactEmail,
                        address: _this.address,
                        no: _this.rollNo,
                        attendeeName: _this.attendeeName,
                        position: _this.attendeePosition,
                        venue: _this.venue,
                        workshop1: _this.workshop1,
                        workshop2: _this.workshop2,
                        workshop3: _this.workshop3,
                        workshop4: _this.workshop4,
                        workshop5: _this.workshop5,
                        workshop6: _this.workshop6,
                        lunch: _this.lunch
                    })
                        .done(function (data) {
                            var feedbackBox = jQuery('.bs-callout-warning'), responseHTML = '';
                            if (data.return === 'success') {
                                responseHTML = "<p><strong>Thank you for submitting your booking.</strong></p><p>A confirmation email has been sent to your email address.</p><p>If you do not receive the confirmation message please check your junk email folder.</p>";
                                feedbackBox.attr('class', 'bs-callout-warning alert alert-success');
                                jQuery('form#form-register-event').css('display', 'none');
                                jQuery("#event-title").html("Booking Submitted");
                            } else if (data.return === 'no space') {
                                responseHTML = "<p>There is no more space for this event</p>";
                                feedbackBox.attr('class', 'bs-callout-warning alert alert-danger');
                            } else {
                                responseHTML = "<p>Something is not right. Please try to book again after refreshing the page.</p>";
                                feedbackBox.attr('class', 'bs-callout-warning alert alert-danger');
                            }
                            jQuery('html, body').animate({
                                scrollTop: 0 // height of the header
                            }, 1000);
                            feedbackBox.html(responseHTML);
                        })
                        .fail(function (data) {
                            var feedbackBox = jQuery('.bs-callout-warning'), responseHTML = '';
                            responseHTML = "<p>Something is not right. Please try to book again after refreshing the page.</p>";
                            feedbackBox.attr('class', 'bs-callout-warning alert alert-danger');
                            jQuery('html, body').animate({
                                scrollTop: 0 // height of the header
                            }, 1000);
                            feedbackBox.html(responseHTML);
                        });
                }

            }
        }
    });
}
//parsley with jquery
jQuery(document).ready(function () {
    (function () {

        if (jQuery('form#form-register-event').length > 0) {
            jQuery('form#form-register-event').parsley().on('form:validate', function (formInstance) {
                form.formNoError = (formInstance.isValid({group: 'form', force: true}) && formInstance.isValid({group: 'attendee', force: true}) && form.attendeeName.length > 0);
            });
        }
    })();
});
/*for reCAPTCHA in event registration form*/
var onReturnCallback = function (response) {
    var url = '/proxy.php?response=' + response;
    jQuery.ajax({
        'url': url,
        dataType: 'json',
        data: {response: response},
        success: function (result) {
            if (result) {
                jQuery('#completed_captcha').val(1);
                jQuery('form#form-register-event').parsley().validate({group: 'recaptcha'});
            }
        }
    });
};